import { Paragraph, Section, Title } from "./style";

export default function Post({ post }) {
  if (!post) return;

  return (
    <>
      <Section key={post.sys.id}>
        <div>
          <Title>{post.fields.title}</Title>
          <Paragraph>{post.fields.description}</Paragraph>
        </div>
        <img src={post.fields.image.fields.file.url} className="img" />
      </Section>
    </>
  );
}
